import { ApiResponse } from "../../../types/api";
import apiClient from "../../apiClient";
import { Permission, PermissionsResponse, GetPermissionsParams } from "./type";

const PERMISSIONS_ENDPOINT = "/permissions";

export const permissionService = {
  getPermission: async (id: string): Promise<Permission> => {
    const response = await apiClient.get<ApiResponse<Permission>>(
      `${PERMISSIONS_ENDPOINT}/${id}`,
    );
    return response.data.data;
  },

  getPermissions: async (
    params: GetPermissionsParams = {},
  ): Promise<PermissionsResponse> => {
    const searchParams = new URLSearchParams();

    if (params.skip !== undefined) {
      searchParams.append("skip", params.skip.toString());
    }
    if (params.limit !== undefined) {
      searchParams.append("limit", params.limit.toString());
    }
    if (params.search) {
      searchParams.append("search", params.search);
    }

    const response = await apiClient.get<ApiResponse<PermissionsResponse>>(
      `${PERMISSIONS_ENDPOINT}/?${searchParams.toString()}`,
    );
    return response.data.data;
  },

  getAllPermissions: async (): Promise<Permission[]> => {
    // First, get the total count
    const countResponse = await apiClient.get<ApiResponse<PermissionsResponse>>(
      `${PERMISSIONS_ENDPOINT}/?limit=1`,
    );
    const total = countResponse.data.data.total || 100;

    // Then fetch all permissions with the actual total
    const response = await apiClient.get<ApiResponse<PermissionsResponse>>(
      `${PERMISSIONS_ENDPOINT}/?limit=${total}`,
    );
    return response.data.data.permissions || [];
  },
};

export type { Permission, PermissionsResponse, GetPermissionsParams };
